import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../messages';

const Step7Shared = () => (
  <ol>
    <li>
      <FormattedMessage {...messages.other1} />
    </li>
    <li>
      <FormattedMessage {...messages.other2} />
    </li>
    <li>
      <FormattedMessage {...messages.other3} />
    </li>
    <li>
      <FormattedMessage {...messages.other4} />
    </li>
    <li>
      <FormattedMessage {...messages.other5} />
    </li>
    <li>
      <FormattedMessage {...messages.other6} />
    </li>
  </ol>
);

export default Step7Shared;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step7/components/Step7Shared.js